// import config from '@/config/app-cfg'

/* handy object & functions */
var rules = {
  required: (val) => val !== '' || 'Required',
  mobile: (val) => {
    const pattern = /^[0-9]+$/
    return pattern.test(val) || val === '' || 'Invalid mobile number'
  },
  email: (val) => {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(val) || 'E-mail address must be valid'
  }
}

var customToolbar = [
  ['bold', 'italic', 'underline'],
  [{'header': ['1', '2']}],
  [{'list': 'ordered'}]
]

// format the date to DB date
function formatDBDate (dt) {
  var d = new Date(dt)
  var month = '' + (d.getMonth() + 1)
  var day = '' + d.getDate()
  var year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day
  return [year, month, day].join('-')
}

// format to desired date to display
function formatDate (dt) {
  var d = new Date(dt)
  var month = '' + (d.getMonth() + 1)
  var day = '' + d.getDate()
  var year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [day, month, year].join('-')
}

// format to desired long date to display
function formatLongDate (dt) {
  var d = new Date(dt)
  var month = d.getMonth()
  var day = '' + d.getDate()
  var year = d.getFullYear()
  if (day.length < 2) day = '0' + day
  return [day, getMonthName(month), year].join(' ')
}

// get month name
function getMonthName (m) {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return monthNames[m]
}

// format to desired date to display
function formatDateTime (dt) {
  var str = ''
  var today = new Date()
  var d = new Date(dt)
  // check for short forms
  var diff = today - d
  var min = diff / 60000
  var hr = min / 60
  if (hr < 1) {
    str = Math.round(min) + ' min'
  } else if (hr < 12) {
    str = Math.round(hr) + ' hr'
  } else { // long time
    str = d.toDateString()
    // strip year if the current year
    if (today.getFullYear() === d.getFullYear()) {
      str = str.substring(0, str.indexOf(today.getFullYear()))
    }
    // with am/pm
    var hours = d.getHours()
    var minutes = d.getMinutes()
    var ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    hours = hours !== 0 ? hours : 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes
    str += ' ' + hours + ':' + minutes + ' ' + ampm
  }
  return str
}

// get time from date
function getTime12Hrs (dt) {
  var d = new Date(dt)
  var hours = d.getHours()
  var minutes = d.getMinutes()
  var ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours !== 0 ? hours : 12 // the hour '0' should be '12'
  hours = hours < 10 ? '0' + hours : hours
  minutes = minutes < 10 ? '0' + minutes : minutes
  return (hours + ':' + minutes + ' ' + ampm)
}

// get time from date
function getTime (dt) {
  var d = new Date(dt)
  d = ('00' + d.getHours()).slice(-2) + ':' +
  ('00' + d.getMinutes()).slice(-2)
  return d
}

// get time including sec from date
function getLongTime (dt) {
  var d = new Date(dt)
  d = ('00' + d.getHours()).slice(-2) + ':' +
  ('00' + d.getMinutes()).slice(-2) + ':' +
  ('00' + d.getSeconds()).slice(-2)
  return d
}

// format to desired time to display
function formatTime (t) {
  var str = ''
  var hours = t.substring(0, 2)
  var minutes = t.substring(3, 5)
  var ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours !== 0 ? hours : 12 // the hour '0' should be '12'
  str = hours + ':' + minutes + '' + ampm
  return str
}

// format to desired time to store in DB
function formatDBTime (t) {
  var str = ''
  var hours = t.substring(0, 2)
  var minutes = t.substring(3, 5)
  str = hours + ':' + minutes
  return str
}

function dateDiffInDays (a, b) {
  var _MS_PER_DAY = 1000 * 60 * 60 * 24
  // Discard the time and time-zone information.
  var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())
  var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())
  return Math.floor((utc2 - utc1) / _MS_PER_DAY)
}

function dateDiffInMins (a, b) {
  var _MS_PER_MIN = 1000 * 60
  return Math.round((b - a) / _MS_PER_MIN)
}

function getDatesBetween (startDate, stopDate) {
  var dateArray = []
  var currentDate = startDate
  while (currentDate <= stopDate) {
    dateArray.push(new Date(currentDate))
    currentDate = addDays(currentDate, 1)
  }
  return dateArray
}

function addDays (dt, days) {
  var date = new Date(dt)
  date.setDate(date.getDate() + days)
  return date
}

// first letter capital
function startWithUpper (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

/* water quality terms whose casing is retained as it is, whichever way they
   were keyed in */
var knownCasing = {
  ph: 'pH',
  tds: 'TDS',
  tss: 'TSS',
  cod: 'COD',
  bod: 'BOD',
  do: 'DO',
  ec: 'EC',
  orp: 'ORP',
  mpn: 'MPN',
  ntu: 'NTU',
  frc: 'FRC'
}

/* bring a master name to title case - each word capitalised. */
function titleCase (str) {
  var words = (str || '').trim().split(/\s+/)
  var allCaps = words.every(function (word) { return word === word.toUpperCase() })
  return words.map(function (word) {
    if (knownCasing[word.toLowerCase()]) {
      return knownCasing[word.toLowerCase()]
    }
    if (word.length > 1 && word === word.toUpperCase() && !allCaps) {
      return word
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  }).join(' ')
}

// bring a master code (uom and the like) to caps
function capsCase (str) {
  return (str || '').trim().toUpperCase()
}

// function & style to display html content comes out of vue2-editor (to fix spacing issues)
function getEditorStyle () {
  return '<style>p {margin-top:0; margin-bottom:0} ol {margin-left:40px}</style>'
}

function fixHtmlSpacing (str) {
  return str.replace(/<p><br><\/p>/g, '<br>')
}

function unique (list) {
  return list.filter((x, i, a) => a.indexOf(x) === i)
}

function diff (a, b) {
  return a.filter((i) => b.indexOf(i) < 0)
}

// function to format currency based on the config
function formatCur (amt) {
  var pfix = ''
  var sfix = ''
  amt = amt || 0
  if (amt < 0) {
    amt = Math.abs(amt)
    pfix = '('
    sfix = ')'
  }
  return pfix + amt.toLocaleString('en-IN', {
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'INR'
  }) + sfix
}

function formatDBDateTime (dt) {
  var date = new Date(dt)
  date = date.getFullYear() + '-' +
  ('00' + (date.getMonth() + 1)).slice(-2) + '-' +
  ('00' + date.getDate()).slice(-2) + ' ' +
  ('00' + date.getHours()).slice(-2) + ':' +
  ('00' + date.getMinutes()).slice(-2) + ':' +
  ('00' + date.getSeconds()).slice(-2)
  return date
}

function formatDisplayDateTime (dt) {
  var date = new Date(dt)
  var str = ('00' + date.getDate()).slice(-2) + '-' +
  ('00' + (date.getMonth() + 1)).slice(-2) + '-' +
  date.getFullYear() + ' '
  var hours = ('00' + date.getHours()).slice(-2)
  var minutes = ('00' + date.getMinutes()).slice(-2)
  var ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours !== 0 ? hours : 12 // the hour '0' should be '12'
  str = str + hours + ':' + minutes + '' + ampm

  return str
}

function html2text (str) {
  return str.replace(/<[^>]*>?/gm, ' ')
}

function loadImg (path, isShared = false) {
  try {
    return isShared ? ('https://us-fm-space.blr1.digitaloceanspaces.com/' + path) : ('https://us-bb-space.blr1.digitaloceanspaces.com/' + path)
    // return isShared ? ('https://uniservice-fm-storage.blr1.digitaloceanspaces.com/' + path) : ('https://uniservice-bb-storage.blr1.digitaloceanspaces.com/' + path)
    // return isShared ? ('assets/common/' + path) : ('./assets/' + path)
  } catch (e) {
    return 'assets/unknown.png'
  }
}

// validate a picked image file against allowed types & max size, returns true or an error message
function validateImageFile (file, maxSizeMB = 5) {
  var allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
  if (!allowedTypes.includes(file.type)) {
    return 'Only JPG, JPEG and PNG images are allowed'
  }
  if (file.size > maxSizeMB * 1024 * 1024) {
    return 'Image size should not exceed ' + maxSizeMB + ' MB'
  }
  return true
}

// function to format number
function formatNum (amt) {
  var pfix = ''
  var sfix = ''
  amt = amt || 0
  if (amt < 0) {
    amt = Math.abs(amt)
    pfix = '('
    sfix = ')'
  }
  return pfix + amt.toLocaleString('en-IN', {
    maximumFractionDigits: 0
  }) + sfix
}

module.exports = {
  rules,
  customToolbar,
  formatDate,
  formatLongDate,
  formatDateTime,
  formatDBDate,
  getMonthName,
  getTime,
  getLongTime,
  formatTime,
  formatDBTime,
  dateDiffInDays,
  dateDiffInMins,
  getDatesBetween,
  startWithUpper,
  titleCase,
  capsCase,
  getEditorStyle,
  fixHtmlSpacing,
  unique,
  diff,
  formatCur,
  formatNum,
  formatDBDateTime,
  formatDisplayDateTime,
  getTime12Hrs,
  html2text,
  loadImg,
  validateImageFile
}
